// OrdersLayout.js
import React, { useState } from 'react';
import useStore from '../../store/zustandstore';
import OrdersSideNav from './orderssidenav';

const OrdersLayout = ({ children, tab,setTab,data }) => { // Accept props here
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isSidenav = useStore((state) => state.ordersSidenav);
  const marginLeftClass = isCollapsed ? 'ml-[20%] sm:ml-[4%]' : 'ml-[10%] sm:ml-[15%] md:ml-[17%]';

  if (!isSidenav) {
    return children;
  }

  return (
    <div className="flex">
      <OrdersSideNav isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} tab={tab} setTab={setTab} data={data} />
      <div className={`flex-grow p-4  bg-[#FAFAF9] min-h-screen ${marginLeftClass}`}>
          {children}
      </div>
    </div>
  );
};

export default OrdersLayout;
